/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `admin` - Admin
 * * `member` - Member
 * * `developer` - Developer
 */
export enum UserRoleEnum {
    ADMIN = 'admin',
    MEMBER = 'member',
    DEVELOPER = 'developer',
}
